import clsx from 'clsx';
import React from 'react';

import styles from './Checkbox.module.scss';

type Props = {
    label: React.ReactNode;
    checked: boolean;
    onChange: (checked: boolean) => void;
    isMultiSelect?: boolean;
    customStyles?: React.CSSProperties;
    disabled?: boolean;
};

const Checkbox: React.FC<Props> = ({ label, checked, onChange, isMultiSelect, customStyles, disabled = false }) => {
    return (
        <label
            className={clsx(styles.Checkbox, {
                [styles.MultiSelect]: isMultiSelect,
                [styles.Disabled]: disabled,
            })}
            onClick={(e) => {
                e.stopPropagation();
                // Fully suppress the click when disabled — covers browsers (e.g. iOS Safari) where a
                // label click can otherwise still toggle the wrapped input.
                if (disabled) e.preventDefault();
            }}
            style={customStyles}
        >
            <input type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
            <span className={styles.Checkmark}></span>
            {label}
        </label>
    );
};

export default Checkbox;
